/**
 * Procedure Categories and Procedures for M.Ch. in Endocrine Surgery students
 * Extracted with strict evidence from official NMC PDF (Page 8-13, 35: "Psychomotor domain - perform independently")
 */
export const ENDOCRINE_SURGERY_PROCEDURES = {
  "Thyroid & Parathyroid Surgical Procedures": [
    "Hemi, Near-Total & Total Thyroidectomy for Benign & Malignant Thyroid Diseases",
    "Total Thyroidectomy with Central & Lateral Compartmental Neck Lymph Node Dissection",
    "Retrosternal & Mediastinal Goiter Resection",
    "Sistrunk Procedure for Thyroglossal Duct Cyst / Fistula Excision",
    "Parathyroidectomy (Focused & Bilateral Neck Exploration) & Parathyroid Auto-Transplantation",
    "Minimally Invasive & Endoscopic / Robotic Thyroidectomy (BABA / TOETVA)",
  ],
  "Adrenal & Neuroendocrine Pancreatic (GEP-NET) Surgical Procedures": [
    "Open & Laparoscopic Transabdominal / Retroperitoneal Adrenalectomy",
    "Cortical-Sparing & Bilateral Adrenalectomy",
    "Paraganglioma & Pheochromocytoma Resection",
    "Enucleation of Pancreatic Neuroendocrine Tumors (Insulinoma / Gastrinoma)",
    "Pancreatoduodenectomy & Distal Pancreatectomy for GEP-NETs & MEN Syndromes",
  ],
  "Breast Surgery, Oncoplastic & Thymic Surgical Procedures": [
    "Mastectomy (Simple, Palliative, Skin-Sparing & Modified Radical Mastectomy / MRM)",
    "Breast Conservation Surgery (BCS) & Wide Local Excision / Lumpectomy",
    "Sentinel Lymph Node Biopsy (SLNB) & Axillary Lymph Node Dissection (ALND)",
    "Oncoplastic Breast Surgery & Post-Mastectomy Breast Reconstruction",
    "Transcervical, Transsternal & VATS / Robotic Thymectomy for Thymoma",
    "Parotidectomy & Submandibular Gland Resection",
  ],
};

export const ENDOCRINE_SURGERY_CATEGORIES = Object.keys(ENDOCRINE_SURGERY_PROCEDURES);

export const isMChInEndocrineSurgeryDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("endocrine surgery") ||
    d.includes("endocrine & breast surgery")
  );
};
